export default "__VITE_ASSET__BhfGs$xc__"